








// import React, { useState, useContext } from 'react';
// import { useNavigate, Navigate } from 'react-router-dom';
// import { useMutation ,useQueryClient } from 'react-query';
// import Cookies from 'js-cookie';
// import { useToast } from '@chakra-ui/react';
// import {
//   Button,
//   Flex,
//   FormControl,
//   FormLabel,
//   Heading,
//   Input,
//   Stack,
//   Image,
//   Box,
//   Text,
// } from '@chakra-ui/react';
// import i from '../../assets/6a0f3738606f195c4f3d5886cdb825f5.png';
// import logo from '../../assets/eba836181a8bb389cc40f37585eec6ae.png';
// import LoginSchema from '../../validations/loginvalidations';
// import { PostData } from '../../api/apiFactory';
// // import { AdminContext } from '../../context/AdminContext';

// export default function Login({ auth }) {
//   const [err, setErr] = useState({});
//   const navigate = useNavigate();
//   const toast = useToast();
//   // const userAdmin = useContext(AdminContext);

//   const queryClient = useQueryClient();
//   const mutation = useMutation((formData) => PostData('/admin/login', formData), {
//     onSuccess: (data) => {
//       console.log(data.data,"data")
//       // queryClient.invalidateQueries('users');

//       if (data.status === 200) {
//         Cookies.set('token', JSON.stringify(data?.data?.token), { expires: 1 });
//         Cookies.set('user', JSON.stringify(data?.data?.data?.admin), { expires: 1 });
//         navigate('/dashboard');
//       }
//     },
//     onError: (error) => {
//       toast({
//         title: 'Error',
//         description: error.response?.data?.message || 'An error occurred',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     },
//   });

//   // Redirect logic if already logged in
//   if (auth || Cookies.get('token')) {
//     return <Navigate to="/dashboard/home" />;
//   }
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     const formData = new FormData(e.target);
//     const loginData = Object.fromEntries(formData);

//     try {
//       await LoginSchema.validate(loginData, { abortEarly: false });
//       mutation.mutate(loginData);
//     } catch (error) {
//       if (error.inner) {
//         const newError = {};
//         error.inner.forEach((err) => {
//           newError[err.path] = err.message;
//         });
//         setErr(newError);
//       } else {
//         setErr({});
//       }
//     }
//   };

//   return (
//     <form onSubmit={handleLogin}>
//       <Box h={'100vh'}>
//         <Stack h={'100%'} direction={{ base: 'column', md: 'row' }}>
//           <Flex p={8} flex={1} align={'center'} justify={'center'}>
//             <Stack spacing={4} w={'full'} maxW={'md'}>
//               <Box mb={'10px'}>
//                 <Image alt={'Login Image'} objectFit={'cover'} width={'40%'} height={'80%'} src={logo} />
//               </Box>
//               <Heading fontSize={'2xl'}>Sign in to your account</Heading>
//               <FormControl id="email">
//                 <FormLabel>email</FormLabel>
//                 <Input type="text" name="email" />
//               </FormControl>
//               <FormControl id="password">
//                 <FormLabel>Password</FormLabel>
//                 <Input type="password" name="password" />
//               </FormControl>
//               <Stack spacing={6}>
//                 <Button isLoading={mutation.isLoading} type="submit" colorScheme={'blue'} variant={'solid'}>
//                   Sign in
//                 </Button>
//               </Stack>
//               <Box alignContent={'center'}>
//                 {Object.keys(err).map((key, index) => (
//                   <Text textAlign={'center'} color={'red.500'} key={index}>
//                     {err[key]}
//                   </Text>
//                 ))}
//               </Box>
//             </Stack>
//           </Flex>
//           <Flex display={{ base: 'none', md: 'block' }} flex={1}>
//             <Image alt={'Login Image'} objectFit={'cover'} width={'100%'} height={'100%'} src={i} />
//           </Flex>
//         </Stack>
//       </Box>
//     </form>
//   );
// }







import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import Cookies from 'js-cookie';
import { useToast } from '@chakra-ui/react';
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Image,
  Box,
  Text,
} from '@chakra-ui/react';
import i from '../../assets/6a0f3738606f195c4f3d5886cdb825f5.png';
import logo from '../../assets/eba836181a8bb389cc40f37585eec6ae.png';
import LoginSchema from '../../validations/loginvalidations';
import { PostData } from '../../api/apiFactory';

export default function Login({ auth }) {
  const [err, setErr] = useState({});
  const navigate = useNavigate();
  const toast = useToast();
  const queryClient = useQueryClient();

  useEffect(() => {
    const userCookieadmin = Cookies.get('token');
    const user = Cookies.get('user');

    if (userCookieadmin && user) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const mutation = useMutation((formData) => PostData('/admin/login', formData), {
    onSuccess: (data) => {
      if (data.status === 200) {
        Cookies.set('token', JSON.stringify(data?.data?.token), { expires: 1 });
        Cookies.set('user', JSON.stringify(data?.data?.data?.admin), { expires: 1 });
        navigate('/dashboard');
      }
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'An error occurred',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const loginData = Object.fromEntries(formData);

    try {
      await LoginSchema.validate(loginData, { abortEarly: false });
      mutation.mutate(loginData);
    } catch (error) {
      if (error.inner) {
        const newError = {};
        error.inner.forEach((err) => {
          newError[err.path] = err.message;
        });
        setErr(newError);
      } else {
        setErr({});
      }
    }
  };

  return (
    <form onSubmit={handleLogin}>
      <Box h={'100vh'}>
        <Stack h={'100%'} direction={{ base: 'column', md: 'row' }}>
          <Flex p={8} flex={1} align={'center'} justify={'center'}>
            <Stack spacing={4} w={'full'} maxW={'md'}>
              <Box mb={'10px'}>
                <Image alt={'Login Image'} objectFit={'cover'} width={'40%'} height={'80%'} src={logo} />
              </Box>
              <Heading fontSize={'2xl'}>Sign in to your account</Heading>
              <FormControl id="email">
                <FormLabel>Email</FormLabel>
                <Input type="text" name="email" />
              </FormControl>
              <FormControl id="password">
                <FormLabel>Password</FormLabel>
                <Input type="password" name="password" />
              </FormControl>
              <Stack spacing={6}>
                <Button isLoading={mutation.isLoading} type="submit" colorScheme={'blue'} variant={'solid'}>
                  Sign in
                </Button>
              </Stack>
              <Box alignContent={'center'}>
                {Object.keys(err).map((key, index) => (
                  <Text textAlign={'center'} color={'red.500'} key={index}>
                    {err[key]}
                  </Text>
                ))}
              </Box>
            </Stack>
          </Flex>
          <Flex display={{ base: 'none', md: 'block' }} flex={1}>
            <Image alt={'Login Image'} objectFit={'cover'} width={'100%'} height={'100%'} src={i} />
          </Flex>
        </Stack>
      </Box>
    </form>
  );
}

